import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * 车位合同账单
 */
import contractAdd from './add';
import parkingLotContract from './parkingLotContract';
import { fetchCreate, fetchUpdate, fetchChargeBill, fetchDetail } from '@/api/PMS/customerService/leaseContract/contractList';
export default {
  components: {
    contractAdd: contractAdd,
    parkingLotContract: parkingLotContract
  },
  props: {
    couldGenerateBill: Boolean,
    // 能否生成账单
    isUpdateContract: Boolean,
    // 是否是更改合同
    showDialog: Boolean,
    keyValue: {
      type: Number,
      default: -1
    },
    renewalId: {
      // 续签id
      type: [String || Number],
      default: ''
    },
    contractBaseData: {
      // 基础信息
      type: Object,
      default: function _default() {
        return {};
      }
    },
    clauseListData: {
      // 租赁条款
      type: Array,
      default: function _default() {
        return [];
      }
    },
    standardListData: {
      // 收费标准
      type: Array,
      default: function _default() {
        return [];
      }
    },
    parkingLotlist: {
      // 租赁车位信息
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      baseData: {},
      baseInfoObj: {},
      parkingLotBaseData: {},
      // 合同基本信息
      activeName: '',
      list: null,
      clauseList: [],
      standardList: [],
      parkingLotlistOption: [],
      isGenerate: true,
      // 是否已经生成账单
      listLoading: false
    };
  },
  watch: {
    showDialog: function showDialog(n, o) {
      if (n) this.init();
    }
  },
  mounted: function mounted() {
    this.init();
  },
  methods: {
    init: function init() {
      this.activeName = this.isUpdateContract ? 'first' : 'third';

      if (this.keyValue > 0) {
        // this.getDetail(this.keyValue)
        this.handleConfirm();
      } else {
        // this.handleGenerateBill()
        this.handleConfirm();
      }
    },
    handleLeave: function handleLeave(activeName, oldActiveName) {
      var _this = this;

      var currentTime = new Date().getTime(); // 避免触发两次

      if (currentTime - this.triggerTime < 500 && oldActiveName === 'first' && activeName === 'second') {
        return Promise.reject();
      }

      if (currentTime - this.triggerTime < 500 && oldActiveName === 'second' && activeName === 'third') {
        return Promise.reject();
      }

      this.triggerTime = currentTime;
      var p = new Promise(function (resolve, reject) {
        if (oldActiveName === 'first' && activeName === 'second') {
          var isThrough = _this.$refs.baseInfo.handleNext();

          isThrough ? resolve() : reject();
        } else if (oldActiveName === 'second' && activeName === 'third') {
          var _isThrough = _this.$refs.contract.handleGeneratingBills();

          if (_isThrough) {
            console.log('isthrogh');

            _this.handleGenerateBill();

            resolve();
          } else {
            reject();
          }
        } else {
          resolve();
        }
      });
      return p;
    },
    handleClick: function handleClick(val) {
      if (val.paneName === 'first') {
        this.jumpToFrist();
      } else if (val.paneName === 'second') {
        this.jumpToSecond();
      } else {
        this.jumpToThird();
      }
    },
    jumpToFrist: function jumpToFrist() {
      this.activeName = 'first';

      if (this.keyValue < 0) {
        this.baseData = Object.keys(this.contractBaseData).length > 0 ? this.contractBaseData : {};
      } else {
        this.baseData = this.parkingLotBaseData;
      }
    },
    jumpToSecond: function jumpToSecond() {
      this.activeName = 'second';

      if (this.keyValue < 0) {
        this.clauseList = this.clauseListData;
        this.standardList = this.standardListData;
      }
    },
    jumpToThird: function jumpToThird(state) {
      this.activeName = 'third';
      if (state === 'generate') this.handleGenerateBill();
    },
    receiveAddData: function receiveAddData(obj) {
      this.parkingLotlistOption = obj.parkingLotlist;
      this.baseInfoObj = obj.childData;
    },
    getDetail: function getDetail(id) {
      var _this2 = this;

      this.listLoading = true;
      fetchDetail({
        id: id
      }).then(function (res) {
        _this2.listLoading = false;

        if (res.data.code === 200) {
          var data = res.data.data;
          _this2.list = data.chargeRecordUnsettleds;
          _this2.parkingLotlistOption = data.leaseContractResourceVos.map(function (item) {
            return {
              name: item.resourceCode,
              value: item.resourceId
            };
          });
          var childData = {
            leaseType: data.leaseType,
            areaGroupId: data.areaGroupId,
            customerId: data.customerId,
            contractNo: data.contractNo,
            contractName: data.contractName,
            beginDate: data.beginDate,
            endDate: data.endDate,
            remark: data.remark
          };
          _this2.baseInfoObj = childData;
          _this2.parkingLotBaseData.childData = childData;
          _this2.parkingLotBaseData.childData.areaGroupId = String(data.areaGroupId);
          _this2.parkingLotBaseData.parkingLotlist = data.leaseContractResourceVos;
          _this2.baseData = _this2.parkingLotBaseData;
          _this2.clauseList = data.leaseContractTeamsVos;

          if (data.leaseContractTeamsVos && data.leaseContractTeamsVos.length > 0) {
            _this2.standardList = data.leaseContractTeamsVos[0].leaseContractStandardVos;
          }
        }
      });
    },
    handleGenerateBill: function handleGenerateBill() {
      var _this3 = this;

      var customerId = '';
      var billList = [];

      if (this.keyValue > 0) {
        customerId = this.$refs.baseInfo.childData.customerId;
        this.clauseList = this.$refs.contract.clauseList;
        this.standardList = this.$refs.contract.standardList;
      } else {
        this.baseInfoObj = this.contractBaseData;
        customerId = this.baseInfoObj.customerId;
        this.clauseList = this.clauseListData;
        this.standardList = this.standardListData;
        this.parkingLotlistOption = this.parkingLotlist;
      }

      this.clauseList.forEach(function (contract) {
        contract.leaseContractTeamsResourceVos.forEach(function (resourceId) {
          _this3.standardList.forEach(function (standard) {
            var billObj = {
              beginDate: contract.chargeBeginDate,
              endDate: contract.chargeEndDate,
              costBearers: contract.costBearers,
              resourceId: resourceId,
              customerId: customerId,
              chargeStandardId: standard.chargeStandardId,
              resourceType: 2
            };
            billList.push(billObj);
          });
        });
      });
      this.listLoading = true;
      fetchChargeBill(billList).then(function (res) {
        _this3.listLoading = false;

        if (res.data.code === 200) {
          _this3.list = res.data.data;
        }
      });
    },
    // 生成账单
    handleConfirm: function handleConfirm() {
      var _this4 = this;

      var baseData = {};
      var clauseList = []; // 租赁条款

      var standardList = []; // 租赁条款

      if (this.keyValue > 0) {
        // baseData = this.$refs.baseInfo
        // clauseList = this.$refs.contract.clauseList
        // standardList = this.$refs.contract.standardList
        baseData = this.contractBaseData;
        clauseList = this.clauseListData;
        standardList = this.standardListData;
      } else {
        baseData = this.contractBaseData;
        clauseList = this.clauseListData;
        standardList = this.standardListData;
      }

      var addParams = baseData.childData;
      addParams.leaseContractResourceVos = baseData.parkingLotlist;
      var leaseContractTeamsVos = clauseList;
      leaseContractTeamsVos.forEach(function (item) {
        item.leaseContractStandardVos = standardList;
        item.leaseContractTeamsResourceVos = item.leaseContractTeamsResourceVos.map(function (resourceId) {
          return {
            resourceId: resourceId
          };
        });
      });
      addParams.leaseContractTeamsVos = leaseContractTeamsVos; // addParams.chargeRecordUnsettleds = this.list

      if (this.keyValue > 0 && !this.renewalId) {
        addParams.contractNo = this.keyValue;
        fetchUpdate(addParams).then(function (res) {
          if (res.data.code === 200) {
            _this4.Alert({
              alertType: 'update'
            });

            _this4.$emit('handCancle');
          }
        });
      } else if (this.renewalId) {
        // 续签
        addParams.upContractId = this.renewalId;
        fetchCreate(addParams).then(function (res) {
          if (res.data.code === 200) {
            _this4.Alert({
              alertType: 'add'
            });

            _this4.$emit('handCancle');
          }
        });
      } else {
        fetchCreate(addParams).then(function (res) {
          if (res.data.code === 200) {
            _this4.Alert({
              alertType: 'add'
            });

            _this4.$emit('handCancle');
          }
        });
      }
    },
    handlePrev: function handlePrev() {
      this.activeName = 'second';
    },
    handCancle: function handCancle(state) {
      this.$emit('handCancle');
    }
  }
};